import 'firebase/firestore'
import 'firebase/auth'
import firebase from 'firebase/app'
import EnvUtils from './utils/EnvUtils'

let fbConfigDev = {
  apiKey: "AIzaSyBGLogcnWZT5swag-xzKd4f06kay2Opu4M",
  authDomain: "pgmtc-trinity-gps.firebaseapp.com",
  databaseURL: "https://pgmtc-trinity-gps.firebaseio.com",
  projectId: "pgmtc-trinity-gps",
  storageBucket: "pgmtc-trinity-gps.appspot.com",
  messagingSenderId: "1011297152944",
  appId: "1:1011297152944:web:4ddef14a107390aa737075"
}
let fbConfigProd = {
  apiKey: "AIzaSyDJhJgcuW8RqEmjUQwZQyRo2Aocvk7dTsQ",
  authDomain: "caite-locaite.firebaseapp.com",
  databaseURL: "https://caite-locaite.firebaseio.com",
  projectId: "caite-locaite",
  storageBucket: "caite-locaite.appspot.com",
  messagingSenderId: "598761442757",
  appId: "1:598761442757:web:7a2c633996aaeb2e6bcfac"
}

let fbConfig = EnvUtils.isdev() ? fbConfigDev : fbConfigProd
firebase.initializeApp(fbConfig)
export default firebase
